import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { KeyboardArrowDown } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import BasketIcon from '../../icons/BasketIcon';
import FavoriteButton from '../Favorites/FavoriteButton';
import ModernSystemsIcon from '../../icons/ModernSystemsIcon';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import Grid from "@material-ui/core/Grid";
import Link from '@material-ui/core/Link';
import { ruRU } from '@material-ui/core/locale';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import AppCardTagList from './AppCardTagList';
import AppCardAlternativeList from './AppCardAlternativeList';
import AppListTagArray from './AppListTagArray';
import FilterErr from "../Errors/FilterErr";
import ArrowSendIcon from '../../icons/ArrowSendIcon';
import CustomIconButton from '../CustomIconButton';
import KloStatus from '../KloSatus';
import utils from '../../other/utils';
import KloBanksChoose from '../KloBanksChoose';

const theme = createMuiTheme({
	palette: {
		primary: { main: '#1976d2' },
	},
}, ruRU);

function descendingComparator(a, b, orderBy) {
	const usuallySort = (a, b) => {
		if (b < a) {
			return -1;
		} else if (b > a) {
			return 1;
		} else {
			return 0;
		}
	}
	let numericFields = ['version', 'paymentone', 'paymentmonthly'];
	let sortA = numericFields.includes(orderBy) ? parseFloat(a[orderBy]) : a[orderBy];
	let sortB = numericFields.includes(orderBy) ? parseFloat(b[orderBy]) : b[orderBy];

	if (orderBy === 'version') {
		const getVersToNum = (str) => {
			try {
				let splitedValue = str.split('.');
				splitedValue.map((part, i) => {
					while (splitedValue[i].length < 3) {
						//splitedValue[i] = splitedValue[i]+ '0'
						splitedValue[i] = '0' + splitedValue[i]
					}
				})
				while (splitedValue.length < 4) {
					splitedValue.push('000')
				}
				//console.log(splitedValue,str)
				return splitedValue.join('')
			} catch (e) {
				return str
			}

		}
		sortA = getVersToNum(a[orderBy])
		sortB = getVersToNum(b[orderBy])
		//console.log(sortA, a[orderBy], sortB,b[orderBy])
		if (a.researchmarket !== "" && b.researchmarket !== "") {
			return 0
		} else if (a.researchmarket !== "" || (isNaN(sortB) && !isNaN(sortA))) {
			return 1;
		} else if (b.researchmarket !== "" || (isNaN(sortA) && !isNaN(sortB))) {
			return -1;
		} else if (isNaN(sortB) && isNaN(sortA)) {
			return usuallySort(a[orderBy].toLowerCase(), b[orderBy].toLowerCase())
		} else {
			return sortB - sortA
		}
	} else if (orderBy === 'codeasvul' && a.codeAsvulSort !== undefined) {
		const getCode = (str) => {
			return str.charCodeAt(0)
		}
		let sortA = parseInt(a.codeAsvulSort.replace(/[^0-9]/g, match => getCode(match)))
		let sortB = parseInt(b.codeAsvulSort.replace(/[^0-9]/g, match => getCode(match)))
		//console.log(a[orderBy], b[orderBy], sortB - sortA, a.codeasvul, b.codeasvul ) 
		// if(a.researchmarket !== "" && b.researchmarket !== ""  ) {
		// 	return 0
		// } else if (a.researchmarket !== "" ) {
		// 	return 1;	
		// } else if 	(b.researchmarket !== ""){
		// 	return -1;			

		//} else 
		if (/[0-9]/g.test(a.codeasvul) && !/[0-9]/g.test(b.codeasvul)) {
			return 1;
		} else if (/[0-9]/g.test(b.codeasvul) && !/[0-9]/g.test(a.codeasvul)) {
			return -1;
		}
		else if (!/[0-9]/g.test(a.codeasvul) && !/[0-9]/g.test(b.codeasvul)) {
			return usuallySort(a[orderBy].toLowerCase(), b[orderBy].toLowerCase(), orderBy)

		} else {
			return sortB - sortA;
		}

	} else if (numericFields.includes(orderBy)) {

		if (a.researchmarket !== "" && b.researchmarket !== "") {
			return sortB - sortA
		} else if (a.researchmarket !== "" && (a[orderBy] === 0 || a[orderBy] === -1)) {
			return 1;
		} else if (b.researchmarket !== "" && (b[orderBy] === 0 || b[orderBy] === -1)) {
			return -1;
		} else return sortB - sortA;

	} else if (!isNaN(sortB) && !isNaN(sortA)) {

		return sortB - sortA;
	} else if (isNaN(sortB) && isNaN(sortA)) {
		return usuallySort(a[orderBy].toLowerCase(), b[orderBy].toLowerCase(), orderBy)
	}



	if (sortB < sortA) {
		return -1;
	}
	if (sortB > sortA) {
		return 1;
	}
	return 0;
}

function getComparator(order, orderBy) {
	// if (orderBy === 'title') { orderBy = 'codeasvul' }
	if (orderBy === 'datestartsale') { orderBy = 'sortingdatestartsale' }

	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator, init = false) {
	if (init) {
		return array
	}
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
	const { classes, order, orderBy, onRequestSort, cart, lang, inCu } = props;

	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};

	let headCells = [];
	if ((props.bank && (props.bank == "cftbank" || props.bank == "cft-management-risks") || window.location.pathname.indexOf("/applications/apptags") > -1)) {
		headCells.push(
			{ id: 'codeasvul', numeric: false, disablePadding: false, label: translate.TableView[`Code${lang}`] },
			{ id: 'version', numeric: true, disablePadding: false, label: translate.Words[`Version${lang}`] },
			{ id: 'datestartsale', numeric: false, disablePadding: false, label: translate.Words[`ReleaseDate${lang}`] },
			{ id: 'bn_title', numeric: false, disablePadding: false, label: translate.Words[`BusinessArea${lang}`] },
			{ id: 'sn_title', numeric: false, disablePadding: false, label: translate.Words[`Section${lang}`] },
			{ id: 'tags', numeric: false, disablePadding: false, sortable: false, label: translate.Words[`Tags_${lang}`] },
			{ id: 'paymentone', numeric: true, disablePadding: false, label: translate.Words[`Price1${lang}`] },
			{ id: 'paymentmonthly', numeric: true, disablePadding: false, label: translate.Words[`Price2${lang}`] },
			{ id: '', numeric: false, disablePadding: false, sortable: false, label: translate.Words[`Add${lang}`], width: 50 },
		)
	} else {
		headCells.push(
			{ id: 'codeasvul', numeric: false, disablePadding: false, label: translate.TableView[`Code${lang}`] },
			{ id: 'version', numeric: true, disablePadding: false, label: translate.Words[`Version${lang}`] },
			{ id: 'datestartsale', numeric: false, disablePadding: false, label: translate.Words[`ReleaseDate${lang}`] },
			{ id: 'bn_title', numeric: false, disablePadding: false, label: translate.Words[`BusinessArea${lang}`] },
			{ id: 'sn_title', numeric: false, disablePadding: false, label: translate.Words[`Section${lang}`] },
			{ id: 'paymentone', numeric: true, disablePadding: false, label: translate.Words[`Price1${lang}`] },
			{ id: 'paymentmonthly', numeric: true, disablePadding: false, label: translate.Words[`Price2${lang}`] },
			// { id: '', numeric: false, disablePadding: false, sortable: false, label: translate.Words[`AddToFavorite${lang}`], width: 50 },
			{ id: '', numeric: false, disablePadding: false, sortable: false, label: translate.Words[`Add${lang}`] },
		)
	}


	return (
		<React.Fragment>
			<TableHead>
				<TableRow>
					{headCells.map((headCell) => (
						<TableCell
							className={classes.THCellCap2}
							key={headCell.id}
							align='left'
							padding={headCell.disablePadding ? 'none' : 'default'}
							sortDirection={orderBy === headCell.id ? order : false}
							style={{ width: headCell.width }}
						>
							{
								headCell.id !== '' && headCell.id !== 'tags'
									?
									<TableSortLabel
										active={orderBy === headCell.id}
										direction={orderBy === headCell.id ? order : 'asc'}
										onClick={createSortHandler(headCell.id)}
										IconComponent={KeyboardArrowDown}
									>
										{headCell.label}
										{orderBy === headCell.id ? (
											<span className={classes.visuallyHidden}>
												{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
											</span>
										) : null}
									</TableSortLabel>
									:
									cart && headCell.label === translate.Words[`AddTobasket${lang}`]
										?
										translate.Words[`RemoveFromBasket${lang}`]
										:
										headCell.label

							}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		</React.Fragment>
	);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	// onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		padding: '0 12px',
	},

	paper: {
		marginTop: 24,
		width: '100%',
		marginBottom: theme.spacing(2),
		borderRadius: theme.spacing(2),
		padding: '0 31px',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: 0
		}
	},

	table: {
		minWidth: 750,
	},

	visuallyHidden: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		top: 20,
		width: 1,
	},

	TCell: {
		minWidth: 95
	},

	TitleCell: {
		minWidth: 204,
		width: 204,
		maxWidth: 204,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'bold',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			minWidth: 157,
			width: 157,
			maxWidth: 157,
			padding: '16px 6px',
		}
	},

	VersionCell: {
		minWidth: 96,
		width: 96,
		maxWidth: 96,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
			// 	minWidth: 264,
			// 	width: 264,
			// 	maxWidth: 264,
		}
	},

	DatestartCell: {
		minWidth: 102,
		width: 102,
		maxWidth: 102,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
		}
	},

	BNCell: {
		minWidth: 204,
		width: 204,
		maxWidth: 204,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
			minWidth: 138,
			width: 138,
			maxWidth: 138,
			wordBreak: "break-word",
		}
	},

	SNCell: {
		minWidth: 204,
		width: 204,
		maxWidth: 204,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
			minWidth: 112,
			width: 112,
			maxWidth: 112,
			wordBreak: "break-word",
		}
	},

	SNCellwT: {
		minWidth: 150,
		width: 150,
		maxWidth: 150,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
			minWidth: 80,
			width: 80,
			maxWidth: 80,
			wordBreak: "break-word",
		}
	},

	Tags: {
		minWidth: 54,
		width: 54,
		maxWidth: 54,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 6px',
		verticalAlign: 'top',

		[theme.breakpoints.down(1702)]: {
			padding: '16px 6px',
			minWidth: 32,
			width: 32,
			maxWidth: 32,
			wordBreak: "break-word",
		}
	},

	PaymentOneCell: {
		minWidth: 160,
		width: 160,
		maxWidth: 160,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'bold',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
			minWidth: 108,
			width: 108,
			maxWidth: 108,
		}
	},

	PaymentMonthlyCell: {
		minWidth: 160,
		width: 160,
		maxWidth: 160,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'bold',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
			minWidth: 108,
			width: 108,
			maxWidth: 108,
		}
	},

	TCellCap2M: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'bold',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
		}
	},

	TCellCap2: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
		}
	},

	THCellCap2: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#8987A2',
		verticalAlign: 'bottom',
		padding: '16px 12px',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
		}
	},

	TCellCap1: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			padding: '16px 6px',
		}
	},

	icon: {
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	LinkType12: {
		fontSize: '13px',
		lineHeight: '16px',
		fontWeight: 400,
		color: '#24262A',
		textDecoration: 'none',
		borderBottom: '1px dashed rgba(0, 0, 0, 0.4)',

		'&:hover': {
			color: '#2050FF',
			textDecoration: 'none',
			borderBottom: '1px dashed #2050FF',
		}
	},
}));

export default function EnhancedTable(props) {
	let { cardArr, type, checkAll, setCheckAll, notDeleteFromBasketArr, removeApp, notDeleteFromBasketArrCloud, cart, countApp ,isSearch} = props

	// const [basketChips, _appBasket] = useState(JSON.parse(localStorage.getItem('cartApp')) || [])
	const classes = useStyles();
	const [order, setOrder] = React.useState('asc');
	const [orderBy, setOrderBy] = React.useState('codeasvul');
	const lang = localStorage.getItem('language') || 'Ru';
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(50);
	const [appBasket, _appBasket] = useState(JSON.parse(localStorage.getItem('cartApp')) || []);
	const [init, _init] = useState(true);
	const kloUser = props.kloUser
	let inCu = props.userCollection.CatalogCu || props.userCollection.inCu;
	let date = new Date();

	// function createData(codeasvul, version, datestartsale, bn_title, sn_title, paymentone, paymentmonthly) {
	// 	return { codeasvul, version, datestartsale, bn_title, sn_title, paymentone, paymentmonthly, };
	// }

	// const rows = [
	// 	cardArr.map((item) =>
	// 		createData(item)
	// 	)
	// ];


	function handleRequestSort(event, property) {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
		_init(false);
	};

	function setApp(prod) {
		setCheckAll(!checkAll)
		if (JSON.parse(localStorage.getItem('cartApp')).some((element) => element === prod.ID) === true) {
			_appBasket(JSON.parse(localStorage.getItem('cartApp')).filter(el_ => el_ !== prod.ID))
			let r = JSON.parse(localStorage.getItem('cartApp')) || []
			localStorage.setItem('cartApp', JSON.stringify(r.filter(el_ => el_ !== prod.ID)))

		} else {
			_appBasket(JSON.parse(localStorage.getItem('cartApp')).concat(prod.ID))
			let r = JSON.parse(localStorage.getItem('cartApp')) || []
			localStorage.setItem('cartApp', JSON.stringify(r.concat(prod.ID)))
		}
	}

	function setAppBasket(prod) {
		setCheckAll(!checkAll)
		if (appBasket.some((element) => element === prod.ID) === true) {
			_appBasket(appBasket.filter(el_ => el_ !== prod.ID))
			let r = JSON.parse(localStorage.getItem('cartApp')) || []
			localStorage.setItem('cartApp', JSON.stringify(r.filter(el_ => el_ !== prod.ID)))
		} else {
			_appBasket(appBasket.concat(prod.ID))
			let r = JSON.parse(localStorage.getItem('cartApp')) || []
			localStorage.setItem('cartApp', JSON.stringify(r.concat(prod.ID)))
		}
	}

	function handleChangePage(event, newPage) {
		setPage(newPage);
		window.scrollTo(0, 0)
	};

	function handleChangeRowsPerPage(event) {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	function SkeletonRow() {
		return (
			<TableRow tabIndex={-1}>
				<TableCell align="left" className={classes.TitleCell} style={{ padding: '16px 12px' }}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.VersionCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.DatestartCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.BNCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={props.bank && (props.bank == "cftbank" || props.bank == "cft-management-risks") ? classes.SNCellwT : classes.SNCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				{props.bank && (props.bank == "cftbank" || props.bank == "cft-management-risks")
					?
					<TableCell align="left" className={classes.Tags}>
						<Skeleton animation="wave" variant="rect" height={48} />
					</TableCell>
					:
					null
				}

				<TableCell align="left" className={classes.PaymentOneCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.PaymentMonthlyCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.TCell} style={lang == 'En' ? { minWidth: 50, width: 50, maxWidth: 50, padding: 0 } : { minWidth: 82, width: 82, maxWidth: 82 }}>
					<Skeleton animation="wave" variant="circle" height={48} />
				</TableCell>
			</TableRow>
		)
	}

	/* ЦЕНА ПО АКЦИИ >>>>> */
	function ActionPriceOne(paymentonestock, paymentone) {
		if (paymentonestock) {
			if (paymentonestock < paymentone) {
				return (
					parseFloat(paymentonestock).toLocaleString('ru-RU', { maximumFractionDigits: 3 })
				)
			}
		}
	}

	function ActionPriceMonthly(paymentmonthlystock, paymentmonthly) {
		if (paymentmonthlystock) {
			if (paymentmonthlystock < paymentmonthly) {
				return (
					parseFloat(paymentmonthlystock).toLocaleString('ru-RU', { maximumFractionDigits: 3 })
				)
			}
		}
	}
	/* <<<<< ЦЕНА ПО АКЦИИ */

	const handleDelete = (chipToDelete) => () => {
		props.setArrayTag(props.arrayTag.filter((chip) => chip.key !== chipToDelete.key));
	};

	function disablePriority(codeasvul, RESEARCHMARKETMAILS) {
		if (props.usname !== null) {
			if (props.disablePriorityBtn && props.disablePriorityBtn.includes(codeasvul)) {
				return (true)
			} else if (RESEARCHMARKETMAILS) {
				return (props.usname === null ? true : RESEARCHMARKETMAILS.includes(props.usname.email))
			}
		} else {
			return (true)
		}
	}

	const renderAppPriceTooltip = (type, row, field, field2 = 'paymentonestock') => {
		if (inCu === '1' && row.Currency === 1) {
			inCu = '0'
		} else if (inCu !== '1' && row.Currency === 0) {
			inCu = '1'
		}

		if (inCu === '1' && row.Currency !== 1 && typeof row[field] === 'number' && row[field] > 0) {
			return (
				<CustomTooltip title={<span>
					{translate.Words[`CurrentRate_${lang}`]}
					{/* <br />{translate.Words[`NextRate_${lang}`]} */}
				</span>}>
					<span style={{ color: +row[field2] > 0 && +row[field2] < +row[field] ? '#8987A2' : '', textDecoration: +row[field2] > 0 && +row[field2] < +row[field] ? 'line-through' : '' }}>
						{
							utils.getCurrentPrice(row[field], lang, ' (' + utils.getPriceItem(inCu, lang, type) + ')')
						}
					</span>
				</CustomTooltip>
			)
		} else if (inCu === '1' && row.Currency === 1 || true) {
			return (
				<span style={{ color: +row[field2] > 0 && +row[field2] < +row[field] ? '#8987A2' : '', textDecoration: +row[field2] > 0 && +row[field2] < +row[field] ? 'line-through' : '' }}>
					{
						utils.getCurrentPrice(row[field], lang, ' (' + utils.getPriceItem(inCu, lang, type) + ')')
					}
				</span>
			)
		} else {
			return (
				<span style={{ color: +row[field2] > 0 && +row[field2] < +row[field] ? '#8987A2' : '', textDecoration: +row[field2] > 0 && +row[field2] < +row[field] ? 'line-through' : '' }}>
					{
						row.researchmarket !== "" && +row[field] < 0
							?
							'-'
							:
							+row[field] === 0
								?
								translate.Words[`NotCharged${lang}`]
								:
								parseFloat(row[field]).toLocaleString('ru-RU', { maximumFractionDigits: 3 }) + ' (' + utils.getPriceItem(inCu, lang, type) + ')'
					}
				</span>
			)
		}
	}

	const renderPriceCells = (row) => {
		if (row.isHidePrice === 1) {
			return (
				<React.Fragment>
					<TableCell align="left" className={classes.PaymentOneCell}>
						<HtmlTooltip
							interactive
							title={<Grid item dangerouslySetInnerHTML={{ __html: row.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}></Grid>}>
							<span>{lang === 'Ru' ? 'По запросу' : 'On request'}</span>
						</HtmlTooltip>
					</TableCell>

					<TableCell align="left" className={classes.PaymentMonthlyCell}></TableCell>
				</React.Fragment>
			)
		} else {
			return (
				<React.Fragment>
					<TableCell align="left" className={classes.PaymentOneCell}>
						<Grid>
							{ActionPriceOne(row.paymentonestock, row.paymentone)}
						</Grid>

						{renderAppPriceTooltip('elp', row, 'paymentone')}

						<HtmlTooltip
							interactive
							title={
								row.paymentcommentone?.length > 5
									?
									<Grid item dangerouslySetInnerHTML={{ __html: row.paymentcommentone }} style={{ fontSize: '14px !important' }}></Grid>
									:
									row.paymentcommentone !== '*'
										?
										null
										:
										<Grid item dangerouslySetInnerHTML={{ __html: row.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}>
										</Grid>
							}
						>
							<Typography component='span' className={classes.pricePrimary} style={{ cursor: 'default', maxWidth: 5, fontSize: '13px' }}>{row.paymentcommentone?.length > 5 ? '*' : row.paymentcommentone}</Typography>
						</HtmlTooltip>

						<HtmlTooltip
							interactive
							title={
								row.paymentcomment?.length > 5
									?
									<Grid item dangerouslySetInnerHTML={{ __html: row.paymentcomment }} style={{ fontSize: '14px !important' }}>
									</Grid>
									:
									row.paymentcomment !== '*'
										?
										null
										:
										<Grid item dangerouslySetInnerHTML={{ __html: row.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}>
										</Grid>
							}
						>
							<Typography component='span' className={classes.pricePrimary} style={{ cursor: 'default', maxWidth: 5, fontSize: '13px' }}>{row.paymentcomment?.length > 5 ? '*' : row.paymentcomment}</Typography>
						</HtmlTooltip>
					</TableCell>

					<TableCell align="left" className={classes.PaymentMonthlyCell}>
						<Grid>
							{ActionPriceMonthly(row.paymentmonthlystock, row.paymentmonthly)}
						</Grid>

						{renderAppPriceTooltip('lp', row, 'paymentmonthly', 'paymentmonthlystock')}

						<HtmlTooltip
							interactive
							title={
								row.paymentcommentmonthly?.length > 5
									?
									<Grid item dangerouslySetInnerHTML={{ __html: row.paymentcommentmonthly }} style={{ fontSize: '14px !important' }}>
									</Grid>
									:
									row.paymentcommentmonthly !== '*'
										?
										null
										:
										<Grid item dangerouslySetInnerHTML={{ __html: row.Fullpaymentcomment }} style={{ fontSize: '14px !important' }}>
										</Grid>
							}
						>
							<Typography component='span' className={classes.pricePrimary} style={{ cursor: 'default', maxWidth: 5, fontSize: '13px' }}>{row.paymentcommentmonthly?.length > 5 ? '*' : row.paymentcommentmonthly}</Typography>
						</HtmlTooltip>
					</TableCell>
				</React.Fragment>
			)
		}
	}

	const sortArrayByDirection = (arr, directions = []) => {
		if (directions.length > 0 && Array.isArray(arr)) {
			const dirIds = directions.map(el => el.ID_BN)

			let newArr = arr.filter(el => dirIds.includes(el.businessdirectionid)).concat(arr.filter(el => !dirIds.includes(el.businessdirectionid)))
			//console.log("sortArrayByDirection",dirIds, arr, newArr)
			return newArr
		} else {
			return arr
		}
	}

	const renderFavoritesIcon = (row, isCart, appFavorite, appsInProducts) => {
		let appInFavorite = appFavorite && appFavorite.includes(row.ID);
		let title = appInFavorite ? translate.Words[`RemoveFromFavorite${lang}`] : translate.Words[`AddToFavorite${lang}`];
		let fill = appInFavorite ? '#FFFFFF' : '#BCBBD0';
		let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'app', 'favorite'); if (isCart && !!props.updateArr) { props.updateArr('favorite', row, 'app'); } };
		let backgroundColor = appInFavorite ? '#EB505E' : undefined;
		if (appsInProducts.includes(row.ID)) {
			fill = '#BCBBD0';
			backgroundColor = undefined;
			title = translate.Words[`AppIsPartOfProducts_${lang}`];
			onClick = () => { }
		}


		return (
			row.dateendsale.length > 2 || row.researchmarket.length > 2 || row.isModernSystems === 1
				?
				null
				:
				<FavoriteButton fill={fill} title={title} onClick={onClick} needMarginBottom backgroundColor={backgroundColor} />
		)
	}

	const renderBasketIcons = (row, isBasket, appBasket, appsInProducts) => {
		if (row.researchmarket == "Изучается спрос" || row.researchmarket == "Demand under research") {
			return (
				<HtmlTooltip
					interactive
					title={
						props.usname === null
							?
							lang === 'Ru'
								?
								<Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы повысить приоритет </Grid>
								:
								<Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to raise priority </Grid>
							:
							row.RESEARCHMARKETMAILS && row.RESEARCHMARKETMAILS.includes(props.usname.email)
								?
								<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`YourVoteHasBeenRegistered${lang}`]} </Grid>
								:
								<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`ClickToIncreasePriority${lang}`]} </Grid>
					}
				>
					<Grid item>
						<CustomIconButton
							aria-label="share"
							className={classes.icon}
							disabled={disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS)}
							func={() => props.upPriority(row.RESEARCHMARKETMAILS, row.codeasvul)}
							bgcolor={'#F6F6FB'}
							hbgcolor={'#5D75F8'}
							shadow={'none'}
							hshadow={'0px 6px 24px rgba(128, 148, 255, 0.4)'}
							icon={props.usname === null ? 1 : disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS) ? 2 : 1}
							discolor={disablePriority(row.codeasvul, row.RESEARCHMARKETMAILS) ? '#EEEEF5' : null}
						/>
					</Grid>
				</HtmlTooltip>
			)
		} else if (row.isModernSystems === 1) {
			return (
				<IconButton onClick={() => window.open(`https://${row.ModernSystemLink}`)} color={'primary'} aria-label="share" className={classes.icon} style={{ backgroundColor: appBasket && appBasket.includes(row.ID) ? '#7D62BA' : '' }}>
					<ModernSystemsIcon fill={appBasket && appBasket.includes(row.ID) ? '#FFFFFF' : '#BCBBD0'} />
				</IconButton>
			)
		} else {
			//console.log("appBasket",appBasket,notDeleteFromBasketArr, )
			let appInBasket = appBasket && appBasket.includes(row.ID);
			let title = appInBasket ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`];

			//let onClick = isBasket ? () => {removeApp(row)} : () => {setAppBasket(row)} ;
			let backgroundColor = appInBasket ? '#EB505E' : undefined;
			let fill = appInBasket ? '#FFFFFF' : '#BCBBD0'
			let onClick = /*isBasket ?*/ async () => { await props.saveCollection(row.ID, 'app', 'cart'); if (!!props.updateArr) { props.updateArr('cart', row, 'app'); } };

			if (appsInProducts.includes(row.ID)) {
				fill = '#BCBBD0';
				backgroundColor = undefined;
				title = translate.Words[`AppIsPartOfProducts_${lang}`];
				onClick = () => { }
			}
			return (
				row.dateendsale.length > 2 || row.researchmarket.length > 2
					?
					null
					:
					<CustomTooltip placement="top" title={title}>
						<IconButton color={'primary'} aria-label="share" onClick={onClick} className={classes.icon} style={{ backgroundColor }}>
							<BasketIcon fill={fill} />
						</IconButton>
					</CustomTooltip>
			)
		}
	}

	return (
		<ThemeProvider theme={theme}>
			<div className={classes.root}>
				{
					window.location.pathname.indexOf("/applications/apptags") > -1
						?
						<AppListTagArray
							arrayTag={props.arrayTag}
							setArrayTag={handleDelete}
							clearChips={() => props.clearChips()}
						/>
						:
						<Grid container style={{ height: 12, display: props.cardArr.length < 1 ? 'none' : 'block' }}></Grid>
				}

				{
					props.loading
						?
						<Paper className={classes.paper}>
							<TableContainer>
								<Table
									className={classes.table}
									aria-labelledby="tableTitle"
									aria-label="enhanced table"
								>
									<EnhancedTableHead
										classes={classes}
										order={order}
										orderBy={orderBy}
										cart={cart}
										// onSelectAllClick={handleSelectAllClick}
										onRequestSort={handleRequestSort}
										rowCount={cardArr.length}
										lang={lang}
										bank={props.bank}
									/>
									<TableBody>
										{SkeletonRow()}
									</TableBody>
								</Table>
							</TableContainer>
						</Paper>
						:
						props.cardArr.length > 0
							?
							<Paper className={classes.paper}>
								<TableContainer style={{ overflowX: 'hidden' }}>
									<Table
										className={classes.table}
										aria-labelledby="tableTitle"
										aria-label="enhanced table"
									>
										<EnhancedTableHead
											classes={classes}
											order={order}
											orderBy={orderBy}
											cart={cart}
											// onSelectAllClick={handleSelectAllClick}
											onRequestSort={handleRequestSort}
											rowCount={cardArr.length}
											lang={lang}
											bank={props.bank}
											inCu={inCu}
										/>
										<TableBody>
											{
												sortArrayByDirection(stableSort(props.cardArr, getComparator(order, orderBy), init && isSearch === true || init && props.init && props.parent === 'catalog'), init && props.init && props.parent === 'catalog' ? [] : props.idsDirection)
													.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
													.map((row, index) => {
														// const isItemSelected = isSelected(row.title);
														// const labelId = `enhanced-table-checkbox-${index}`;kloU
														const kloHref = `${utils.getKLOLink()}/monthly/${utils.getKLOMonth()}?server_part=${kloUser && kloUser.currentServerPart ? kloUser.currentServerPart : ''}&codeasvul=${row.codeasvul}`
														return (
															// <Link href={`/${type}/card/${row['codeasvul']}`} style={{ textDecoration: 'none' }} target="_blank">
															<TableRow
																// hover
																// onClick={(event) => handleClick(event, row.title)}
																// role="checkbox"
																// aria-checked={isItemSelected}
																tabIndex={-1}
																key={row.codeasvul}
															// selected={isItemSelected}
															>
																<TableCell align="left" className={classes.TitleCell}>
																	{
																		row.isHideAppLink === 1 || row.systemid === 34
																			?
																			<React.Fragment>
																				<Grid item container direction="row" justify="flex-start" alignItems="center">
																					<div>
																						{
																							row.researchmarket
																								?
																								null
																								:
																								row.codeasvul
																						}
																					</div>
																					{
																						row.researchmarket
																							?
																							<CustomTooltip title={"Приоритеты разработки"} placement="right">
																								<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#8094FF' }}></div>
																							</CustomTooltip>
																							:
																							null
																					}

																					{
																						row.announcement
																							?
																							<CustomTooltip title={row.announcement} placement="right">
																								<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#FE9D67' }}></div>
																							</CustomTooltip>
																							:
																							null
																					}

																					{
																						row.standartpackage
																							?
																							<CustomTooltip title={row.standartpackage} placement="right">
																								<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#81D39D' }}></div>
																							</CustomTooltip>
																							:
																							null
																					}

																					{
																						row.promo
																							?
																							<CustomTooltip title={row.promo} placement="right">
																								<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#DF6291' }}></div>
																							</CustomTooltip>
																							:
																							null
																					}

																					{row.dateendsale
																						?
																						<CustomTooltip title={row.dateendsale} placement="right">
																							<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#BCBBD0' }}></div>
																						</CustomTooltip>
																						:
																						null
																					}
																					{row.isNew === 1
																						?
																						<CustomTooltip title={translate.Words[`New${lang}`]} placement="right">
																							<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#81D39D' }}></div>
																						</CustomTooltip>
																						:
																						null
																					}
																				</Grid>

																				<br />
																				{row.title}
																				<br />
																				<div style={{ marginTop: 8 }}>{row.Title_catalog}</div>
																			</React.Fragment>
																			:
																			row.isModernSystems === 1
																				?
																				<Link component="a" href={`https://${row.ModernSystemLink}`} target="_blank" color='inherit'>
																					<Grid item container direction="row" justify="flex-start" alignItems="center">
																						<div>
																							<span style={{ color: '#7D62BA' }}>{row.codeasvul}</span>
																						</div>

																						{row.isModernSystems === 1
																							?
																							<CustomTooltip title={translate.Words[`ModernSystems_${lang}`]} placement="right">
																								<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#7D62BA' }}></div>
																							</CustomTooltip>
																							:
																							null
																						}

																						{
																							row.isCloudApp
																								?
																								<CustomTooltip title={row.isCloudApp} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#67C8FE' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}
																						{
																							row.isNew === 1
																								?
																								<CustomTooltip title={translate.Words[`New${lang}`]} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#81D39D' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}
																					</Grid>

																					<br />
																					{row.title}
																					<br />
																					<div style={{ marginTop: 8, fontSize: '12px', lineHeight: '14px', fontStyle: 'normal', fontWeight: 400 }}>С сайта «Современные Системы»</div>
																				</Link>
																				:
																				<Link component="a" href={`/${type}/card/${row['codeasvul']}`} target="_blank" color='inherit'>
																					<Grid item container direction="row" justify="flex-start" alignItems="center">
																						<div>
																							{
																								row.researchmarket
																									?
																									null
																									:
																									row.codeasvul
																							}
																						</div>
																						{
																							row.researchmarket
																								?
																								<CustomTooltip title={"Приоритеты разработки"} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#8094FF' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}

																						{
																							row.announcement
																								?
																								<CustomTooltip title={row.announcement} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#FE9D67' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}

																						{
																							row.standartpackage
																								?
																								<CustomTooltip title={row.standartpackage} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#81D39D' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}

																						{
																							row.promo
																								?
																								<CustomTooltip title={row.promo} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#DF6291' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}

																						{row.dateendsale
																							?
																							<CustomTooltip title={row.dateendsale} placement="right">
																								<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#BCBBD0' }}></div>
																							</CustomTooltip>
																							:
																							null
																						}

																						{
																							row.isCloudApp
																								?
																								<CustomTooltip title={row.isCloudApp} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#67C8FE' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}
																						{
																							row.isNew === 1
																								?
																								<CustomTooltip title={translate.Words[`New${lang}`]} placement="right">
																									<div style={{ height: 12, width: 12, marginLeft: 6, borderRadius: '6px', background: '#81D39D' }}></div>
																								</CustomTooltip>
																								:
																								null
																						}
																					</Grid>

																					<br />
																					{row.title}
																					<br />
																					<div style={{ marginTop: 8 }}>{row.Title_catalog}</div>
																				</Link>

																	}
																	{
																		props.kloStatuses && props.kloStatuses[row.codeasvul] || props.loadingKloStatuses === true
																			?
																			<br />
																			:
																			null
																	}
																	<KloStatus kloUser={props.kloUser} kloStatus={props.kloStatuses && props.kloStatuses[row.codeasvul] || ''} codeasvul={row.codeasvul} loadingKloStatuses={props.loadingKloStatuses} />

																</TableCell>

																<TableCell align="left" className={classes.VersionCell}>
																	{
																		row.researchmarket
																			?
																			null
																			:
																			row.version
																	}
																</TableCell>

																<TableCell align="left" className={classes.DatestartCell}>
																	{
																		row.researchmarket
																			?
																			null
																			:
																			row.datestartsale
																	}
																</TableCell>

																<TableCell align="left" className={classes.BNCell} /* onClick={() => window.open(`/applications/${row.url_catalog}/applist?filt=false&direction=${row.businessdirectionid}`)} */>
																	{
																		row.isModernSystems === 1
																			?
																			<Typography component="p" className={classes.TCellCap1} style={{ padding: 0 }}>
																				{row.ModernSystemBN}
																			</Typography>
																			:
																			cardArr[index].isHideAppLink === 1 || cardArr[index].systemid === 34
																				?
																				<Typography component="p" className={classes.TCellCap1} style={{ padding: 0 }}>
																					{row.bn_title}
																				</Typography>
																				:
																				props.type === 'solutions'
																					?
																					<Typography component="p" className={classes.TCellCap1} style={{ padding: 0 }}>
																						{row.bn_title}
																					</Typography>
																					:
																					<Link component="a" href={`/applications/${row.url_catalog}/applist?filt=false&direction=${row.businessdirectionid}`} className={classes.LinkType12}>
																						{row.bn_title}
																					</Link>
																	}
																</TableCell>

																<TableCell align="left" className={props.bank && (props.bank == "cftbank" || props.bank == "cft-management-risks") ? classes.SNCellwT : window.location.pathname.includes('apptags') ? classes.SNCellwT : classes.SNCell}>
																	{
																		props.type === 'solutions'
																			?
																			<Typography component="p" className={classes.TCellCap1} style={{ padding: 0 }}>
																				{row.sn_title}
																			</Typography>
																			:
																			row.isModernSystems === 1
																				?
																				<Typography component="p" className={classes.TCellCap1} style={{ padding: 0 }}>
																					{row.ModernSystemProduct}
																				</Typography>
																				:
																				<Link component="a" href={`/applications/${row.url_catalog}/applist?filt=false&direction=&section=${row.sectionid}`} className={classes.LinkType12}>
																					{row.sn_title}
																				</Link>
																	}
																</TableCell>

																{(props.bank && (props.bank == "cftbank" || props.bank == "cft-management-risks") || window.location.pathname.indexOf("/applications/apptags") > -1)
																	?
																	<TableCell align="left" className={classes.Tags}>
																		{
																			row.tags_q !== ''
																				?
																				<AppCardTagList
																					tagsQ={row.tags_q}
																					setArrayTag={props.setArrayTag}
																					arrayTag={props.arrayTag}
																					view={'tbl'}
																				/>
																				:
																				null
																		}

																		{
																			row.Alternatives?.length > 0
																				?
																				<AppCardAlternativeList
																					analogs={row.Alternatives}
																					codeasvul={row.codeasvul}
																					inCu={inCu}
																					// arrayTag={props.arrayTag}
																					view={'tbl'}
																				/>
																				:
																				null
																		}
																	</TableCell>
																	:
																	null
																}

																{renderPriceCells(row)}

																<TableCell align="left" className={classes.TCell} style={lang == 'En' ? { minWidth: 50, width: 50, maxWidth: 50, padding: 0 } : {}}>
																	<div disableSpacing className={classes.actions} >
																		<Grid item container style={{ width: 50 }}>
																			{renderFavoritesIcon(row, cart, props.userCollection.appFavorite, props.userCollection.appFavoriteInProduct)}
																			{renderBasketIcons(row, cart, props.userCollection.appBasket, props.userCollection.appCartInProduct)}
																		</Grid>
																	</div>

																</TableCell>
															</TableRow>
														);
													})
											}
										</TableBody>
									</Table>
								</TableContainer>

								{
									kloUser && kloUser.user && kloUser.user.IS_BANK && kloUser.showBankSelect === true && Array.isArray(kloUser.banks) && kloUser.banks.length > 0
										?
										<Table>
											<TableRow>
												<TableCell style={{ padding: 6 }}>
													<Grid container direction="row">
														<Grid item>
															<TablePagination
																rowsPerPageOptions={[50, 100, 150]}
																component="div"
																count={countApp || cardArr.length}
																rowsPerPage={rowsPerPage}
																page={page}
																onChangePage={handleChangePage}
																onChangeRowsPerPage={handleChangeRowsPerPage}
															/>
														</Grid>
														<KloBanksChoose kloUser={kloUser} _kloUser={props._kloUser} delta={536} />

													</Grid>

												</TableCell>
											</TableRow>
										</Table>
										:
										<TablePagination
											rowsPerPageOptions={[50, 100, 150]}
											component="div"
											count={countApp || cardArr.length}
											rowsPerPage={rowsPerPage}
											page={page}
											onChangePage={handleChangePage}
											onChangeRowsPerPage={handleChangeRowsPerPage}
										/>
								}
							</Paper>
							:
							props.err
				}
			</div>
		</ThemeProvider >
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const HtmlTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.87)',
		color: 'rgba(255, 255, 255, 0.87)',
		maxWidth: 500,
		fontSize: theme.typography.pxToRem(12),
		// border: '1px solid #dadde9',
		borderRadius: '8px',
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 400,
		padding: 12,
		// paddingBottom: 0,
		opacity: 0.5,

		'& a': {
			color: 'rgba(255, 255, 255, 0.87)',
		}
	},
}))(Tooltip);